import { render, staticRenderFns } from "./EmailTemplateCategories.vue?vue&type=template&id=5686f534&"
import script from "./EmailTemplateCategories.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplateCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports